module.exports = __webpack_public_path__ + "static/media/vibe.83078c57.png";